export enum DescriptorEnum {

  PERSONAL = 'personal_descriptor',
  CORPORATE = 'corporate_descriptor',
  EVENT = 'event_descriptor',
  GEOGRAPHICAL = 'geographical_descriptor',
  SUBJECT = 'subject_descriptor',
  GENRE = 'genre_descriptor'
}
